import React, { Fragment } from 'react';
import Rater from 'react-rater';

import User from '../User';
import config from '../../config';
import endpoints from '../../lib/endpoints';
import ImageUploader from '../ImageUploader';
import getAverage from '../ReviewsRatings/utils';
import { getCustomToast } from '../ErrorMessage';

import { CHAT_LINKS, modifyChatLinks, getUsableLink } from './utils';

export default function UserBasicInfo(props) {
  const { userId, ratings, noOfReviews, isViewingOwnProfile } = props;

  return (
    <User userId={userId}>
      {({ userData }) => {
        const { chat_platform_links, profile_images } = userData;

        const modifiedChatLinks = chat_platform_links
          ? modifyChatLinks(chat_platform_links)
          : null;

        const selectImage =
          profile_images && profile_images.large
            ? `${config.RESOURCE_URL}/${profile_images.large}`
            : '';

        return (
          <Fragment>
            <div className="hidden-elements">
              <svg viewBox="0 0 266.781 300">
                <defs>
                  <clipPath
                    id="honeyguide-hexagon"
                    clipPathUnits="objectBoundingBox"
                    transform="scale(0.00374839287 0.00333333)"
                  >
                    <path d="M12.959,229.112c-4.763-2.75-8.671-9.5-8.685-15L3.96,85.26c-0.014-5.5,3.878-12.241,8.648-14.979 L124.355,6.126c4.77-2.738,12.569-2.729,17.333,0.021l112.134,64.74c4.763,2.75,8.671,9.5,8.685,15l0.314,128.853 c0.014,5.5-3.878,12.241-8.648,14.979l-111.747,64.154c-4.77,2.738-12.569,2.729-17.333-0.021L12.959,229.112z" />
                  </clipPath>
                </defs>
              </svg>
              <svg viewBox="0 0 269.781 303">
                <defs>
                  <clipPath
                    id="honeyguide-hexagon-border"
                    clipPathUnits="objectBoundingBox"
                    transform="scale(0.00374839287 0.00333333)"
                  >
                    <path d="M12.959,229.112c-4.763-2.75-8.671-9.5-8.685-15L3.96,85.26c-0.014-5.5,3.878-12.241,8.648-14.979 L124.355,6.126c4.77-2.738,12.569-2.729,17.333,0.021l112.134,64.74c4.763,2.75,8.671,9.5,8.685,15l0.314,128.853 c0.014,5.5-3.878,12.241-8.648,14.979l-111.747,64.154c-4.77,2.738-12.569,2.729-17.333-0.021L12.959,229.112z" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="col-12 user">
              <div className="user-cover">
                <ImageUploader
                  uploadUrl={`${endpoints.profile.getUserData(userId)}/profile_image`}
                  role={isViewingOwnProfile}
                  pageContext="profile"
                  onUploadFail={handleProfileImageUploadFail}
                >
                  {imgUrl => {
                    return (
                      // <img src={imgUrl ? imgUrl : selectImage} alt={userData.fullname} />
                      <img
                        src="https://s3.amazonaws.com/honeyguide/assets/profile-bg.jpg"
                        alt={userData.fullname}
                      />
                    );
                  }}
                </ImageUploader>
              </div>
              <div className="row user-profile">
                <div className="col-12 col-md-3">
                  <div className="user-profile-image">
                    <ImageUploader
                      uploadUrl={`${endpoints.profile.getUserData(userId)}/profile_image`}
                      role={isViewingOwnProfile}
                      pageContext="profile"
                      onUploadFail={handleProfileImageUploadFail}
                    >
                      {imgUrl => {
                        return (
                          <div className="profile-hexagon-border">
                            <div
                              className="profile-hexagon"
                              style={{
                                backgroundImage: `url(${imgUrl ? imgUrl : selectImage})`,
                              }}
                            >
                              <img
                                src={imgUrl ? imgUrl : selectImage}
                                alt={userData.fullname}
                                className="d-none"
                              />
                            </div>
                          </div>
                        );
                      }}
                    </ImageUploader>
                  </div>
                </div>
                <div className="col-12 col-md-9 ">
                  <div className="user-profile-info">
                    <h1 className="user-profile-name">{userData.fullname}</h1>
                    <ul className="user-profile-list">
                      {modifiedChatLinks &&
                        CHAT_LINKS.map(link => {
                          if (modifiedChatLinks[link.patch_key].link) {
                            return (
                              <li key={link.patch_key}>
                                <a
                                  href={getUsableLink(
                                    modifiedChatLinks[link.patch_key].link,
                                    link.patch_key
                                  )}
                                  className={link.patch_key}
                                  target="_blank"
                                  rel="nofollow"
                                >
                                  <i className={link.icon} />
                                </a>
                              </li>
                            );
                          }
                          return null;
                        })}
                    </ul>
                    <div className="user-profile-rating">
                      <span>{getAverage(ratings) || 0}</span>
                      <span>
                        <Rater
                          total={5}
                          rating={ratings && getAverage(ratings)}
                          interactive={false}
                        />
                        <p className="count">{noOfReviews ? noOfReviews : '0'} Reviews</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
      }}
    </User>
  );
}

const handleProfileImageUploadFail = error =>
  getCustomToast(
    error.response
      ? error.response.data.message
      : 'Could not upload your image. Please try again later.',
    'error'
  );



// WEBPACK FOOTER //
// ./src/components/Profile/UserBasicInfo.jsx